import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nProvider } from "./i18n/I18nProvider";

function App() {
  return (
    <I18nProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
